// extracted by mini-css-extract-plugin
module.exports = {"routeHeader":"vehicles_routeHeader_3m_bW","addButton":"vehicles_addButton_3h-Ym"};